import { render } from "./AlertPopup.vue?vue&type=template&id=35c02d5c&scoped=true"
import script from "./AlertPopup.vue?vue&type=script&lang=js"
export * from "./AlertPopup.vue?vue&type=script&lang=js"

import "./AlertPopup.vue?vue&type=style&index=0&id=35c02d5c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c02d5c"]])

export default __exports__